<template>
    <div>
        <h3 class="is-size-3">INEGI Geoestadisticas</h3>
        <p>
            <code>GET {{ host }}/api/inegiStates/{stateCode?}</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint tiene un parámetro:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>stateCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato (Ej. 08)</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            {
                geoCode: "08",
                stateCode: "08",
                stateName: "Chihuahua",
                stateAbbr: "Chih.",
                population: "3741869",
                household: "1146915"
            }
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>